module.exports = __webpack_public_path__ + "img/newchris-40.61c89ae3.jpg";